function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Filters
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/filter.scss";
import Popover from "./CBPopover";
import Utils from "./CBUtils";

/**
 * Filter Popover
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Element} data.popoverNode
 * @param {String} data.placement
 * @param {String} data.flipVariations
 * @param {Array} data.offset
 * @param {Number|Object} data.delay
 * @param {Boolean} data.closeOnClickOutside
 * @param {Boolean} data.disableHeightAdjustment
 * @param {Boolean} data.disableHeightAdjustmentAria
 * @param {Function} data.onShow
 * @param {Function} data.onHide
 * @returns {{hide: Function}}
 * @returns {{show: Function}}
 * @returns {{updateTrigger: Function}}
 * @returns {{destroy: Function}}
 */

var CBFilter = function CBFilter() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    popoverNode: null,
    placement: "bottom-start",
    flipVariations: "top-start",
    offset: [0, 8],
    delay: {
      show: 200,
      hide: 100
    },
    closeOnClickOutside: true,
    disableHeightAdjustment: false,
    disableHeightAdjustmentAria: true,
    onShow: null,
    onHide: null
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  if (!Utils.elemExists(elem)) return null;
  var popoverNode = null;
  var header = null;
  var footer = null;
  var shown = false;
  var adjustableContent = null;
  var triggerLabel = elem.innerHTML.trim();
  var popoverIns = null;
  var init = function init() {
    elem.filter = "cb";
    popoverNode = data.popoverNode || document.querySelector("#".concat(elem.getAttribute("aria-controls")));
    adjustableContent = popoverNode.querySelector(".cb-popover-content");
    header = popoverNode.querySelector(".cb-popover-header");
    footer = popoverNode.querySelector(".cb-popover-footer");
    triggerLabel = elem.innerHTML.trim();
    popoverIns = Popover({
      elem: elem,
      popoverNode: popoverNode,
      placement: data.placement,
      flipVariations: data.flipVariations,
      offset: data.offset,
      delay: data.delay,
      closeOnClickOutside: data.closeOnClickOutside,
      filter: true
    });
    elem.addEventListener("click", function (e) {
      e.preventDefault();
      if (Utils.hasClass(elem, "cb-filter-open")) {
        popoverHide(e);
      } else {
        popoverShow(e);
      }
    });
    elem.addEventListener("apricot_popover_hide", function (e) {
      popoverHide(e);
    });
    if (!data.disableHeightAdjustment && Utils.elemExists(adjustableContent)) {
      Utils.addClass(popoverNode, "cb-popover-content-adjust");
      elem.addEventListener("apricot_popover_show", function () {
        shown = true;
        calculateHeight();
      });
      elem.addEventListener("apricot_popover_hide", function () {
        shown = false;
        resetHeight();
      });
    }
  };
  var calculateHeight = function calculateHeight() {
    if (!shown) return;
    var ch = Utils.height(popoverNode);
    var mh = Utils.height(adjustableContent);
    var hh = 0;
    var fh = 0;
    var newHeight = 0;
    if (header) hh = Utils.outerHeight(header);
    if (footer) {
      fh = Utils.outerHeight(footer);
    }
    newHeight = ch - 40 - hh - fh;
    if (mh > newHeight) {
      adjustableContent.style.overflowY = "auto";
      adjustableContent.style.height = newHeight + "px";
      if (!data.disableHeightAdjustmentAria) {
        Utils.attr(adjustableContent, "tabindex", "0");
        Utils.attr(adjustableContent, "role", "region");
        Utils.attr(adjustableContent, "aria-label", "scrollable content");
      }
    } else {
      resetHeight();
    }
  };
  var resetHeight = function resetHeight() {
    adjustableContent.style.overflowY = "hidden";
    adjustableContent.style.height = "auto";
    if (!data.disableHeightAdjustmentAria) {
      Utils.removeAttr(adjustableContent, "tabindex");
      Utils.removeAttr(adjustableContent, "role");
      Utils.removeAttr(adjustableContent, "aria-label");
    }
  };
  var popoverShow = function popoverShow(e) {
    data.onShow && data.onShow(e);
    Utils.addClass(elem, "cb-filter-open");
  };
  var popoverHide = function popoverHide(e) {
    data.onHide && data.onHide(e);
    Utils.removeClass(elem, "cb-filter-open");
  };
  var hide = function hide() {
    popoverIns.hide();
  };
  var show = function show() {
    popoverIns.show();
  };

  /**
   * Updates the label for trigger
   * @method CBFilter#updateTrigger
   * @memberof CBFilter
   * @param {Number} count - Number of selected filters
   * @param {String} label - Actual label of the trigger (optional)
   */
  var updateTrigger = function updateTrigger() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var newLabel = triggerLabel;
    if (label) newLabel = label;
    if (count > 0) {
      newLabel = "".concat(newLabel, " (").concat(count, ")");
    } else {
      newLabel = triggerLabel;
    }
    elem.innerHTML = newLabel;
    if (triggerLabel !== newLabel) {
      Utils.addClass(elem, "cb-filter-active");
    } else {
      Utils.removeClass(elem, "cb-filter-active");
    }
  };
  var destroy = function destroy() {
    if (elem.filter === "cb") {
      elem.filter = null;
      // if (!data.disableHeightAdjustment) {
      // 	window.removeEventListener('resize', calculateHeight);
      // }
    }
  };

  if (elem.filter !== "cb") {
    init();
  }
  return {
    hide: hide,
    show: show,
    updateTrigger: updateTrigger,
    destroy: destroy
  };
};
export default CBFilter;